import { render, staticRenderFns } from "./IconoReparto.vue?vue&type=template&id=3ac964cc&"
import script from "./IconoReparto.vue?vue&type=script&lang=js&"
export * from "./IconoReparto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports